!function (angular) {
    "use strict";
    var myFilters = angular.module("filters", []);

    myFilters.filter("capitalize",
        function () {
            return function (input) {
                return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
            }
        });

    myFilters.filter("contains",
        function () {
            return function (actualString, subString) {
                return (!!actualString) ? (actualString.toLowerCase()
                    .indexOf(subString) > -1) ? true : false : false;
            }
        });

    myFilters.filter('yes_no', ['$translate', function ($translate) {
        return function (text) {
            if (text) {
                return $translate.instant('label.Yes');
            }
            return $translate.instant('label.No');
        }
    }]);

    myFilters.filter('numberToHoursMinutes', ['$translate', function ($translate) {
        return function (minutes) {
            var formattedTime = "";
            var numMinutes = minutes % 60;
            var numHours = Math.floor(minutes / 60);
            if (numHours > 0) {
                formattedTime = formattedTime.concat(numHours + $translate.instant('label.views-service-creation.faultType.hours'));
                formattedTime = formattedTime.concat(numMinutes > 0 ? " " : "");
            }
            if (numMinutes > 0) {
                formattedTime = formattedTime.concat(numMinutes + $translate.instant('label.views-service-creation.faultType.minutes'));
            }
            return formattedTime;
        }
    }]);

}(angular);